// Finds dates written any way ("January 17, 2024", "17 Jan 2024", "01172024", "1/17/24", "2024.01.17", "Jan 2024")
// and rewrites them as MM-DD-YYYY (or MM-YYYY when there's no day) so the rest of the parser always understands them.
const MONTHS = { jan: 1, feb: 2, mar: 3, apr: 4, may: 5, jun: 6, jul: 7, aug: 8, sep: 9, sept: 9, oct: 10, nov: 11, dec: 12 };
const MON = '(jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|june?|july?|aug(?:ust)?|sept?(?:ember)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?)\\.?';
const p2 = (n) => String(+n).padStart(2, '0');
const yr = (y) => { const n = +y; return y.length === 2 ? (n > 40 ? 1900 + n : 2000 + n) : n; };
const ok = (m, d, y) => m >= 1 && m <= 12 && (d == null || (d >= 1 && d <= 31)) && y >= 1900 && y <= 2099;
const fmt = (m, d, y) => (ok(m, d, y) ? (d == null ? `${p2(m)}-${y}` : `${p2(m)}-${p2(d)}-${y}`) : null);
const mon = (s) => MONTHS[s.toLowerCase().replace('.', '').slice(0, s.toLowerCase().startsWith('sept') ? 4 : 3)] || MONTHS[s.toLowerCase().slice(0, 3)];

const RULES = [
  // January 17, 2024 · Jan. 17th 2024 · JAN17 2024
  [new RegExp(`\\b${MON}\\s*(\\d{1,2})(?!\\d)(?:st|nd|rd|th)?(?:,\\s*|\\s+)(\\d{4}|\\d{2})\\b`, 'gi'), (a, M, d, y) => fmt(mon(M), +d, yr(y))],
  // 17 January 2024 · 17th of Jan, 2024
  [new RegExp(`\\b(\\d{1,2})(?:st|nd|rd|th)?\\s*(?:of\\s+)?${MON},?\\s*(\\d{4})\\b`, 'gi'), (a, d, M, y) => fmt(mon(M), +d, +y)],
  // January 2024 · Jan-2024 · Jan '24
  [new RegExp(`\\b${MON}[\\s,'-]*(\\d{4}|'\\d{2})\\b`, 'gi'), (a, M, y) => fmt(mon(M), null, yr(y.replace("'", '')))],
  // 2024-01-17 · 2024/1/17 · 2024.01.17
  [/\b(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})\b/g, (a, y, m, d) => fmt(+m, +d, +y)],
  // 01/17/2024 · 1.17.2024 · 1-17-24 · 01 17 2024
  [/\b(\d{1,2})[-/. ](\d{1,2})[-/. ](\d{4}|\d{2})\b/g, (a, m, d, y) => fmt(+m, +d, yr(y))],
  // 01172024 (MMDDYYYY, no separators)
  [/(?<![\d$.,])(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])((?:19|20)\d{2})(?![\d.,])/g, (a, m, d, y) => fmt(+m, +d, +y)],
  // 012024 (MMYYYY) and 01/2024 · 1-2024
  [/(?<![\d$.,/-])(0[1-9]|1[0-2])[-/.]?((?:19|20)\d{2})(?![\d.,/-])/g, (a, m, y) => fmt(+m, null, +y)],
  // 1/2024 · 9-2019 (single-digit month)
  [/(?<![\d$.,/-])([1-9])[-/.]((?:19|20)\d{2})(?![\d.,/-])/g, (a, m, y) => fmt(+m, null, +y)],
];

export function normalizeDatesInText(text) {
  let out = String(text || '');
  for (const [re, fn] of RULES) out = out.replace(re, (...g) => fn(...g) || g[0]);
  return out;
}

// A line that is nothing but a date → "MM-DD-YYYY" / "MM-YYYY"; otherwise null.
export function parseDateOnly(line) {
  const n = normalizeDatesInText(String(line || '').trim()).trim();
  return /^\d{2}-(\d{2}-)?\d{4}$/.test(n) ? n : null;
}
